// 2-for-1: a place a colleague paid for, "reserved" in the account's online events, whose
// registration isn't complete yet (no attended role there). Mirrors the fullstack's
// getPendingReservedNames (shared/events/getOnlineEventAccess.js). Signing in with such a place
// goes straight to #register to complete it (SignIn/index.vue), as the invitation link does.

const ATTENDED_ROLES = ["participant", "speaker", "organizer", "session-chair", "sponsor"];

// e.g. "masterclass-2026", or "" when there's none
export function getPendingReservedEvent(user) {
  const events = user?.publicMetadata?.events || {};
  const isPending = ([name, deliveries]) => {
    const roles = Array.isArray(deliveries?.online) ? deliveries.online : [];
    const isRegistered = roles.some((role) => ATTENDED_ROLES.includes(role));
    return /-\d{4}$/.test(name) && roles.includes("reserved") && !isRegistered;
  };
  return Object.entries(events).find(isPending)?.[0] || "";
}
